module.exports = __webpack_public_path__ + "static/media/quadro.bca6bc07.jpg";